function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3287"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2987",
  d: "M16.666 43.069c3.815-10.7 9.4-24.08 12.473-26.8C34.021 11.944 49.417 4.017 57.07 2.241c8.879-2.06 89.25-1.647 94.623 4.5s12.748 33.4 12.748 33.4 119.313 3.047 121.364 4.566c6.046 4.479.48 59.711-5.712 61.859-4.074 1.413-128.426 63.424-136.181 62.611-6.752-.709-11.148 2.406-11.747 3.712-.825 1.8.862 16.324.862 16.324l-2.051 2.357-36.363-28.017S73.372 98.474 60.258 95.224s-1.726 31.082-1.726 31.082l-36.71-41.778s-5.517-20.652-7.249-22.94c-1.326-1.753-.174 12.739-.265 12.146",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2988",
  d: "M14.177 73.513c-1.389-1.574-5.876-6.537-6.517-8.434-.418-1.236-.459-11.515-.1-12.581.331-.988 1.527-1.907 2.618-2.741",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2989",
  d: "M18.612 44.628c.918-3.056 6.464-20.493 9.176-23.619s15.689-9.588 20.332-10.308-6.889 37.217-8.411 37.9-22.016-.918-21.097-3.973z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2990",
  d: "M37.337 14.917c-2.559 5.434-7.671 29.894-7.548 33.164",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2991",
  d: "M22.185 57.092a24.329 24.329 0 00.2 4.322l3.058 2.143-.147-5.4s-2.922-2.286-3.111-1.065z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3283"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2992",
  d: "M35.472 63.689a24.327 24.327 0 00.2 4.322l3.058 2.144-.147-5.4s-2.921-2.286-3.111-1.066z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2993",
  d: "M57.034 3.781c-6.614 2.863-9.929 36.916-13.157 47.792s-5.429 14.6.205 37.069c5.314 21.188 5.7 27.748 5.7 27.748",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2994",
  d: "M55.179 47.149c-1.112-6.453 2.789-36.124 9.1-37.984s40.017-2.415 45.988-2.269c5.2.128 38.413-.52 41.467 4.792s11.887 28.25 10.61 28.325c-17.118.96-106.981 8.204-107.165 7.136z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2995",
  d: "M47.038 51.52c16.521 3.221 81.65 19.3 97.864 18.405s131.876-17.553 140.9-22.055",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2996",
  d: "M133.069 189.257c3.266 4.814 10.344 17.134 22.762 13.7s74.023-33.86 83.235-39.367 21.918-13.236 26.9-18.213 17.491-17.452 17.491-17.452 5.911-8.067 6.228-13.467a12.683 12.683 0 00-1.133-4.556c-.976-1.732-8.052-3.466-8.052-3.466",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2997",
  d: "M149.898 69.488c3.009 11 9.64 76.073 4.036 96.411",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2998",
  d: "M155.824 150.449c-5.973 2.04-7.34 3.039-8.624 3.046-3.941.022-11.267.643-15.64-1.107-.944-.378-10.9-7.075-11.089-8.057-1.115-5.82-1.445-23.2-1.9-25.8-.543-3.088-6.9-11.276-7.05-12.422-.367-2.88-1.136-15.226-.513-15.46 1.356-.513 13.93 4.695 16.565 5.368 3.582.914 16.91 1.07 22.17.817 1.336-.064 3.678-1.6 3.678-1.6",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2999",
  d: "M51.649 109.265c-1.511-7.93-4.927-31.716 6.907-34.354 13.886-3.1 34.282 43.5 38.893 67.973",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3284"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 29",
  cx: 27.694,
  cy: 5.121,
  rx: 27.694,
  ry: 5.121,
  transform: "scale(-1) rotate(74.7 81.795 -139.684)",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3285"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 30",
  cx: 38.975,
  cy: 9.741,
  rx: 38.975,
  ry: 9.741,
  transform: "scale(-1) rotate(74.7 90.67 -146.083)",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3000",
  d: "M61.294 118.706c1.515-3.113 9.736-6.989 12.117-7.321",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3001",
  d: "M82.64 192.57c4.2-.005 11.53-1.828 17.312-4.667 4.634-2.275 5.128-4.96 5.488-6.555a25.665 25.665 0 00.439-9.141",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3002",
  d: "M18.418 42.232c-1.616.956-3.911 1.778-4.8.884-.542-.545-.538-4.6-1.283-5.074-.794-.507-7.075-.6-8.059-.232a7.923 7.923 0 00-3.182 3.094c-.4.806.525 6.342 1.56 8.281.422.79 11.588.1 14.227 1.078.2.075 2.434 1.679 2.434 1.679",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3003",
  d: "M16.302 65.893c-4.814 1.044.72 34.723 5.468 36.383 5.112 1.788 8.946.1 10.241-1.526a4.136 4.136 0 001.081-3.415",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3004",
  d: "M240.996 61.309c-1.2 2.8-2.057 10.646-2.057 10.646s12.3-1.529 14.557-3.52 8.618-9.512 7.088-10.575-18.383.649-19.588 3.449z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3005",
  d: "M59.952 48.848l86.341 14.095 129.376-17.952",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3006",
  d: "M213.124 142.148c-4.595 2.722-9.111 2.984-3.992 4.833s14.831 7.253 15.278 10.1-3.747 13.091 1.554 10.406 26.009-12.094 28.818-17.066 7.115-18.881 11.878-21.623 11.608-7.515 11.608-7.515",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3007",
  d: "M251.105 123.204l14.606 6.308",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3008",
  d: "M248.035 126c-1.74 4.391-1.589 14.821-7.974 18.4s-17.6 9.979-17.6 9.979",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3009",
  d: "M221.019 158.059c-13.779 7.061-59.4 30.311-64.766 30.946-3.437.406-9.343.013-12.489-1.185s-8.55-5.978-8.55-5.978",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3010",
  d: "M163.484 44.523c-.071 7.249.786 15.911.786 15.911",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgDriverSideRearQuarterGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290.68,
    height: 204.555,
    viewBox: "0 0 290 205"
  }, props), _ref);
}

export default SvgDriverSideRearQuarterGraphic;